import {
  TBctxHeaderItem,
  TBctxItemWithoutSizeAndBctxKey,
  TRESPONSE_BusinessContextData,
  TWipPackerStore,
  TWipPackerLIneMap,
  TWipPackerCarton,
} from '@monorepo/types';
import { Action } from '@ngrx/store';

export enum TWipPackerStoreActionsType {
  UpdateWipPackerStore = 'UpdateWipPackerStore',
  InitWipPackerStore = 'InitWipPackerStore',
  LoadBctxData = 'LoadBctxData',
  LoadBctxDataSuccess = 'LoadBctxDataSuccess',
  LoadBctxDataFailure = 'LoadBctxDataFailure',
  NoWipPackerAction = 'NoWipPackerAction',
  FillLineMap = 'FillLineMap',
  setSelectedBctxAndHeader = 'setSelectedBctxAndHeader',
  setCurrentCarton = 'setCurrentCarton',
  SaveCarton = 'SaveCarton',
  SaveCartonSuccess = 'SaveCartonSuccess',
  SaveCartonFailure = 'SaveCartonFailure',
  CompleteCarton = 'CompleteCarton',
  DeleteCarton = 'DeleteCarton',
  UndoCarton = 'UndoCarton',
}

export class InitWipPackerStore implements Action {
  readonly type = TWipPackerStoreActionsType.InitWipPackerStore;
}

export class UpdateWipPackerStore implements Action {
  readonly type = TWipPackerStoreActionsType.UpdateWipPackerStore;
  constructor(public state: TWipPackerStore) {}
}

export class LoadBctxData implements Action {
  readonly type = TWipPackerStoreActionsType.LoadBctxData;
}

export class LoadBctxDataSuccess implements Action {
  readonly type = TWipPackerStoreActionsType.LoadBctxDataSuccess;
  constructor(public res: TRESPONSE_BusinessContextData) {}
}

export class LoadBctxDataFailure implements Action {
  readonly type = TWipPackerStoreActionsType.LoadBctxDataFailure;
  constructor(public error: string) {}
}

export class FillLineMap implements Action {
  readonly type = TWipPackerStoreActionsType.FillLineMap;
  constructor(public lineMap: TWipPackerLIneMap) {}
}

export class NoWipPackerAction implements Action {
  readonly type = TWipPackerStoreActionsType.NoWipPackerAction;
}

export class SetSelectedBctxAndHeader implements Action {
  readonly type = TWipPackerStoreActionsType.setSelectedBctxAndHeader;
  constructor(public selectedBctx: TBctxItemWithoutSizeAndBctxKey[], public selectedBctxHeader: TBctxHeaderItem[]) {}
}

export class SetCurrentCarton implements Action {
  readonly type = TWipPackerStoreActionsType.setCurrentCarton;
  constructor(public carton: TWipPackerCarton) {}
}

export class SaveCartonFailure implements Action {
  readonly type = TWipPackerStoreActionsType.SaveCartonFailure;
  constructor(public error: string, public carton: TWipPackerCarton) {}
}

export class SaveCarton implements Action {
  readonly type = TWipPackerStoreActionsType.SaveCarton;
  constructor(public carton: TWipPackerCarton, public index: number) {}
}

export class UndoCarton implements Action {
  readonly type = TWipPackerStoreActionsType.UndoCarton;
  constructor() {}
}

export class SaveCartonSuccess implements Action {
  readonly type = TWipPackerStoreActionsType.SaveCartonSuccess;
  constructor(public carton: TWipPackerCarton, public index: number) {}
}

export class CompleteCarton implements Action {
  readonly type = TWipPackerStoreActionsType.CompleteCarton;
  constructor(public carton: TWipPackerCarton, public index: number) {}
}

export class DeleteCarton implements Action {
  readonly type = TWipPackerStoreActionsType.DeleteCarton;
  constructor(public carton: TWipPackerCarton, public index: number) {}
}

export type TWipPackerStoreActions =
  | InitWipPackerStore
  | LoadBctxData
  | LoadBctxDataSuccess
  | LoadBctxDataFailure
  | FillLineMap
  | SetSelectedBctxAndHeader
  | SetCurrentCarton
  | SaveCarton
  | SaveCartonSuccess
  | SaveCartonFailure
  | UpdateWipPackerStore
  | CompleteCarton
  | DeleteCarton
  | UndoCarton;
